import { useRef, useState } from "react";
import { api, formatErr, imgSrc } from "@/lib/api";

const ReviewPhotos = ({ photos, setPhotos, setErr }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const all = [...(e.target.files || [])];
    const files = all.slice(0, 3 - photos.length);
    e.target.value = "";
    setErr(all.length > files.length ? "Możesz dodać maksymalnie 3 zdjęcia – dodaliśmy pierwsze z wybranych." : "");
    setBusy(true);
    const added = [];
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      try { const { data } = await api.post("/reviews/upload", fd); added.push(data.path); }
      catch (e2) { setErr(`${f.name}: ${formatErr(e2)}`); }
    }
    setBusy(false);
    setPhotos([...photos, ...added]);
  };
  return (
    <div className="field full">
      <span className="legend">Zdjęcia z pobytu (opcjonalnie, max 3)</span>
      <div className="photo-list">
        {photos.map((p) => (
          <div className="photo-thumb" key={p}>
            <img src={imgSrc(p)} alt="" />
            <button type="button" className="photo-x" onClick={() => setPhotos(photos.filter((x) => x !== p))} aria-label="Usuń zdjęcie" data-testid={`review-photo-remove-${photos.indexOf(p)}`}>×</button>
          </div>
        ))}
        {photos.length < 3 && (
          <>
            <input ref={ref} type="file" multiple accept="image/jpeg,image/png,image/webp" hidden onChange={pick} data-testid="review-photo-input" />
            <button type="button" className="photo-add" disabled={busy} onClick={() => ref.current.click()} data-testid="review-photo-add-btn">{busy ? "Wgrywanie…" : "+ Dodaj zdjęcie"}</button>
          </>
        )}
      </div>
    </div>
  );
};

export const ReviewForm = () => {
  const [open, setOpen] = useState(false);
  const [v, setV] = useState({ name: "", occasion: "", text: "", rating: 5 });
  const [photos, setPhotos] = useState([]);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!v.name.trim() || v.text.trim().length < 10) return setErr("Podaj imię i napisz kilka słów (min. 10 znaków).");
    setErr(""); setBusy(true);
    try { await api.post("/reviews", { ...v, photos }); setDone(true); } catch (e2) { setErr(formatErr(e2)); } finally { setBusy(false); }
  };

  if (done) return <p className="review-done" data-testid="review-success">Dziękujemy! Opinia pojawi się na stronie po zatwierdzeniu.</p>;
  if (!open) return <button className="btn line" type="button" style={{ marginTop: 40 }} onClick={() => setOpen(true)} data-testid="review-open-btn">Dodaj swoją opinię</button>;

  return (
    <form className="review-form" onSubmit={submit} noValidate data-testid="review-form">
      <div className="field full">
        <span className="legend">Ocena</span>
        <div className="star-pick" role="radiogroup">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" className={n <= v.rating ? "on" : ""} onClick={() => setV({ ...v, rating: n })} aria-label={`${n} na 5`} data-testid={`review-star-${n}`}>★</button>
          ))}
        </div>
      </div>
      <div className="field"><label htmlFor="r-name">Imię / imiona</label><input id="r-name" value={v.name} onChange={(e) => setV({ ...v, name: e.target.value })} placeholder="Kasia i Michał" data-testid="review-name-input" /></div>
      <div className="field"><label htmlFor="r-occ">Okazja i miejsce</label><input id="r-occ" value={v.occasion} onChange={(e) => setV({ ...v, occasion: e.target.value })} placeholder="Rocznica · domek w górach" data-testid="review-occasion-input" /></div>
      <div className="field full"><label htmlFor="r-text">Twoja opinia</label><textarea id="r-text" value={v.text} onChange={(e) => setV({ ...v, text: e.target.value })} placeholder="Jak wspominacie ten wieczór?" data-testid="review-text-input" /></div>
      <ReviewPhotos photos={photos} setPhotos={setPhotos} setErr={setErr} />
      {err && <p className="err" data-testid="review-error">{err}</p>}
      <div className="field full review-actions">
        <button className="btn solid" type="submit" disabled={busy} data-testid="review-submit-btn">{busy ? "Wysyłanie…" : "Wyślij opinię"}</button>
        <button className="btn line" type="button" onClick={() => setOpen(false)} data-testid="review-cancel-btn">Anuluj</button>
      </div>
    </form>
  );
};
